import TableSortBy from './tableSortBy'

export default TableSortBy
